import React from "react";
import { Leaf, FlaskRound, Globe2 } from "lucide-react"; // 3D-like symbolic icons (from lucide-react)
import { herbal } from "./index";

const OurSuccess = () => {
  const stats = [
    {
      id: 1,
      number: "8",
      label: "Organic Products",
      icon: <Leaf className="w-10 h-10 md:w-12 md:h-12 text-[#c3e88d]" />,
    },
    {
      id: 2,
      number: "4",
      label: "Herbal & Natural",
      icon:  <img src={herbal} alt="Herbal & Natural" className="w-15 h-15 md:w-12 md:h-12" />,
    },
    {
      id: 3,
      number: "4",
      label: "Sustainable",
      icon: <Globe2 className="w-10 h-10 md:w-12 md:h-12 text-[#80cbc4]" />,
    },
  ];

  return (
    <section className="relative w-full bg-gradient-to-br from-[#1d3b1f] via-[#3e6a2b] to-[#1f3f20] py-16 md:py-24 overflow-hidden">
      {/* Background subtle pattern */}
      <div className="absolute inset-0 opacity-10">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.15'%3E%3Ccircle cx='30' cy='30' r='1.5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: "20px 20px",
          }}
        ></div>
      </div>

      <div className="relative max-w-5xl mx-auto px-6 md:px-10 lg:px-12">
        {/* Title */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 tracking-wide drop-shadow-md">
            OUR PRODUCT RANGE
          </h2>
          <div className="w-24 h-1 bg-[#f7ebd0] mx-auto rounded-full shadow-md"></div>
        </div>

        {/* Stat Blocks */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className="relative bg-white/10 backdrop-blur-md rounded-2xl p-8 text-center 
                         transition-all duration-500 transform hover:scale-105 hover:bg-white/20 shadow-lg hover:shadow-2xl"
            >
              {/* 3D Glow Effect */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-white/10 to-transparent opacity-0 group-hover:opacity-20 transition duration-300"></div>

              {/* Icon */}
              <div className="flex justify-center mb-6">
                <div className="w-20 h-20 rounded-full bg-white/10 flex items-center justify-center shadow-inner shadow-[#ffffff33]">
                  {stat.icon}
                </div>
              </div>

              {/* Number */}
              <h3 className="text-5xl font-extrabold text-white drop-shadow-lg mb-2">
                {stat.number}
              </h3>

              {/* Label */}
              <p className="text-[#f7ebd0] uppercase font-semibold tracking-wider text-sm md:text-base">
                {stat.label}
              </p>

              {/* Decorative line */}
              <div className="w-12 h-0.5 bg-[#f7ebd0] mx-auto mt-4 opacity-70"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurSuccess;
